import Markdown from "markdown-to-jsx";

// Thin wrapper over markdown-to-jsx with hardened defaults:
//   - disableParsingRawHTML: assistant content goes through React's
//     escape machinery, no raw <script> or <style> ever lands in
//     the DOM regardless of what the model emits.
//   - Links open in a new tab with noopener+noreferrer so a chat
//     reply can't reach back into the Playground tab.
//
// Styling lives in styles.css under .md-* classes — the wrapper
// just emits semantic HTML; the CSS dresses it up in the light
// register.

interface Props {
  children: string;
}

export function MD({ children }: Props) {
  return (
    <div className="md">
      <Markdown
        options={{
          disableParsingRawHTML: true,
          overrides: {
            a: {
              props: {
                target: "_blank",
                rel: "noopener noreferrer",
              },
            },
          },
        }}
      >
        {children}
      </Markdown>
    </div>
  );
}
